export default __webpack_public_path__ + "static/travel-tips@2x-531495b7e13c49c500552b064ee0a34b.png";